var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedWavesHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67L37.5 66C75 65 150 63 225 63C300 63 375 65 450 66C525 67 600 67 675 66C750 65 825 63 862.5 62L900 61L900 0L862.5 0C825 0 750 0 675 0C600 0 525 0 450 0C375 0 300 0 225 0C150 0 75 0 37.5 0L0 0Z",
    fill: "#8bc6f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 151L37.5 151C75 151 150 151 225 154C300 157 375 163 450 164C525 165 600 161 675 159C750 157 825 157 862.5 157L900 157L900 59L862.5 60C825 61 750 63 675 64C600 65 525 65 450 64C375 63 300 61 225 61C150 61 75 63 37.5 64L0 65Z",
    fill: "#75bcf8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 307L37.5 304C75 301 150 295 225 295C300 295 375 301 450 302C525 303 600 299 675 299C750 299 825 303 862.5 305L900 307L900 155L862.5 155C825 155 750 155 675 157C600 159 525 163 450 162C375 161 300 155 225 152C150 149 75 149 37.5 149L0 149Z",
    fill: "#5db1f7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 385L37.5 382C75 379 150 373 225 373C300 373 375 379 450 380C525 381 600 377 675 376C750 375 825 377 862.5 378L900 379L900 305L862.5 303C825 301 750 297 675 297C600 297 525 301 450 300C375 299 300 293 225 293C150 293 75 299 37.5 302L0 305Z",
    fill: "#4aa3eb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 445L37.5 442C75 439 150 433 225 432C300 431 375 435 450 435C525 435 600 431 675 430C750 429 825 431 862.5 432L900 433L900 377L862.5 376C825 375 750 373 675 374C600 375 525 379 450 378C375 377 300 371 225 371C150 371 75 377 37.5 380L0 383Z",
    fill: "#4190d3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 601L37.5 601C75 601 150 601 225 601C300 601 375 601 450 601C525 601 600 601 675 601C750 601 825 601 862.5 601L900 601L900 431L862.5 430C825 429 750 427 675 428C600 429 525 433 450 433C375 433 300 429 225 430C150 431 75 437 37.5 440L0 443Z",
    fill: "#377ebb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedWavesHaikei);
export default __webpack_public_path__ + "static/media/stacked-waves-haikei.0684b41891bbb3bf8ffc30cc2f1aead7.svg";
export { ForwardRef as ReactComponent };